import { MAP_ENTITIES } from 'app/agriculture/FarmMain/MapRenderer/MapRenderer';
import { GeometryType } from 'app/agriculture/queries/types/geometry/GeometryType';
import { PolygonRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/geometry/PolygonRenderer';
import { PolylineRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/geometry/PolylineRenderer';
import { BillboardRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/geometry/BillboardRenderer';
import { isInfraType } from 'app/agriculture/mutations/types/entityConfig';
import {
    isBillboardEntityType,
    isPolygonEntityType,
    isPolyLineEntityType,
} from 'app/agriculture/models/Entities';

export function MapEntityRenderer({
    entityType,
    geometryType,
}: {
    entityType: (typeof MAP_ENTITIES)[number]['entityType'];
    geometryType: GeometryType;
}) {
    if (!isInfraType(entityType)) return null;
    switch (geometryType) {
        case 'Polygon':
            if (!isPolygonEntityType(entityType)) return null;
            return <PolygonRenderer entityType={entityType} />;
        case 'LineString':
            if (!isPolyLineEntityType(entityType)) return null;
            return <PolylineRenderer entityType={entityType} />;
        case 'Point':
            if (!isBillboardEntityType(entityType)) return null;
            return <BillboardRenderer entityType={entityType} />;
        default:
            return null;
    }
}
